import apiFetch from '../../../utils/apiFetch';
import { sanitizeInventoryItemsForUpdate } from './inventorySanitization';

const messageFrom = async response => {
  try { return (await response.json()).message; } catch { return null; }
};

export async function loadItemInventory(characterId) {
  const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}`, { cache: 'no-store' });
  if (!response.ok) throw new Error(await messageFrom(response) || 'Unable to refresh inventory.');
  const character = await response.json();
  return Array.isArray(character.item) ? character.item : [];
}

export async function saveItemInventory(characterId, items, baseline) {
  if (!Array.isArray(baseline)) throw new Error('Refresh the character before saving inventory.');
  const response = await apiFetch(`/equipment/update-item/${encodeURIComponent(characterId)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ item: sanitizeInventoryItemsForUpdate(items), expectedItem: baseline }),
  });
  if (!response.ok) throw new Error(await messageFrom(response) || 'Inventory could not be saved. Refresh and try again.');
  const result = await response.json();
  if (!Array.isArray(result.item)) throw new Error('Refresh the character to confirm the saved inventory.');
  return result.item;
}
